import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[sdMinNumber]',
  standalone: true,
})
export class MinNumberDirective implements OnInit, OnDestroy {
  @Input('sdMinNumber') minNumber: number;
  @Input() formControl: FormControl;

  private subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(
      this.formControl?.valueChanges.subscribe((value: number) => {
        if (value < this.minNumber) {
          this.formControl.setValue(this.minNumber);
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
